import { Input } from "@/components/ui/input";
import { BTN_PRIMARY, BTN_SECONDARY } from "@/pages/Servers";

export const CHOICES = { coinflip: ["heads", "tails"], dice: ["1", "2", "3", "4", "5", "6"], overunder: ["over", "under", "seven"], roulette: ["red", "black", "odd", "even", "low", "high"] };
export const LABEL = { coinflip: "Coinflip 1.95x", dice: "Dice 5x", overunder: "Over/Under", roulette: "Roulette", blackjack: "Blackjack", mines: "Mines", slots: "Slots", scratch: "Scratch card", crash: "Crash" };
export const TABLE_GAMES = ["blackjack", "mines"];
const PLAY_LABEL = { blackjack: "Deal", mines: "Deal", slots: "Spin", scratch: "Scratch", crash: "Launch" };
const fieldCls = "border-[#1E2D4A] bg-[#050811]";

const DETAIL = {
  slots: (r) => ` · ${r.result.join(" | ")} (${r.multiplier}x)`,
  scratch: (r) => ` · card ${r.result.map((x) => `${x}x`).join(" ")} (${r.multiplier}x)`,
  crash: (r) => ` · crashed at ${r.result}x, cash-out ${r.choice}x`,
};
export const detail = (r) => {
  if (DETAIL[r.game]) return DETAIL[r.game](r);
  if (r.result == null) return "";
  return ` · result ${Array.isArray(r.result) ? r.result.join("+") : r.result}${r.color ? ` ${r.color}` : ""}`;
};
export const outcome = (r, cur) => `${r.won ? "WIN" : r.net === 0 ? "PUSH" : "LOSS"} ${r.net > 0 ? "+" : ""}${r.net} ${cur}`;

export const Blackjack = ({ g, move }) => (
  <div data-testid="bj-table" className="space-y-2 font-mono text-sm">
    <div>Dealer: <span className="text-slate-100">{g.dealer.join(" ")}</span>{g.dealer_value != null && ` (${g.dealer_value})`}</div>
    <div>You: <span className="text-slate-100">{g.player.join(" ")}</span> ({g.player_value})</div>
    {g.status === "active" && <div className="flex gap-2"><button data-testid="bj-hit" onClick={() => move("hit")} className={BTN_PRIMARY}>Hit</button><button data-testid="bj-stand" onClick={() => move("stand")} className={BTN_SECONDARY}>Stand</button></div>}
  </div>
);

const MineTile = ({ t, g, over, move }) => {
  const rev = g.revealed.includes(t), mine = over && (g.mine_tiles || []).includes(t);
  const tone = mine ? "border-red-500 bg-red-500/20" : rev ? "border-emerald-500 bg-emerald-500/15" : "border-[#1E2D4A] bg-[#0B1120] hover:border-[#E5202E]";
  return <button data-testid={`mines-tile-${t}`} disabled={over || rev} onClick={() => move("reveal", t)} className={`h-12 rounded-sm border text-lg transition-colors ${tone}`}>{mine ? "✕" : rev ? "◆" : ""}</button>;
};

export const Mines = ({ g, move }) => {
  const over = g.status !== "active";
  return (
    <div data-testid="mines-board">
      <div className="mb-2 grid w-56 grid-cols-4 gap-1.5">{Array.from({ length: 16 }, (_, t) => <MineTile key={t} t={t} g={g} over={over} move={move} />)}</div>
      {!over && <button data-testid="mines-cashout" disabled={!g.revealed.length} onClick={() => move("cashout")} className={BTN_PRIMARY}>Cash out {g.cashout} (x{g.multiplier})</button>}
    </div>
  );
};

export const GameTable = ({ game, g, move }) => (game === "blackjack" ? <Blackjack g={g} move={move} /> : <Mines g={g} move={move} />);

export const GameTabs = ({ games, game, onPick }) => (
  <div className="mb-4 flex flex-wrap gap-1">{games.map((x) => (
    <button key={x} data-testid={`casino-tab-${x}`} onClick={() => onPick(x)} className={`rounded-sm px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors ${game === x ? "bg-[#E5202E]/15 text-[#E5202E]" : "text-slate-400 hover:text-slate-200"}`}>{LABEL[x]}</button>
  ))}</div>
);

const ChoicePicker = ({ game, choice, setChoice }) => {
  if (!CHOICES[game]) return null;
  if (game === "roulette") return <Input data-testid="casino-choice" required placeholder="red / 17 / odd…" value={choice} onChange={(e) => setChoice(e.target.value)} className={`w-40 ${fieldCls}`} />;
  return (
    <div className="flex gap-1">{CHOICES[game].map((c) => (
      <button type="button" key={c} data-testid={`casino-choice-${c}`} onClick={() => setChoice(c)} className={`rounded-sm border px-3 py-2 text-xs uppercase ${choice === c ? "border-[#E5202E] text-[#E5202E]" : "border-[#1E2D4A] text-slate-400"}`}>{c}</button>
    ))}</div>
  );
};

export const BetForm = ({ game, cfg, f, setF, onSubmit }) => {
  const set = (k) => (v) => setF({ ...f, [k]: v });
  const needsChoice = Boolean(CHOICES[game]) || game === "crash";
  return (
    <form onSubmit={onSubmit} className="flex flex-wrap items-end gap-2">
      <Input data-testid="casino-bet" type="number" min={cfg.min_bet} max={cfg.max_bet} value={f.bet} onChange={(e) => set("bet")(e.target.value)} className={`w-32 font-mono ${fieldCls}`} />
      <ChoicePicker game={game} choice={f.choice} setChoice={set("choice")} />
      {game === "mines" && <Input data-testid="casino-mines" type="number" min={1} max={10} value={f.mines} onChange={(e) => set("mines")(e.target.value)} className={`w-20 font-mono ${fieldCls}`} />}
      {game === "crash" && <Input data-testid="casino-crash-target" type="number" step="0.01" min={1.01} max={100} placeholder="Cash out at e.g. 2" value={f.choice} onChange={(e) => set("choice")(e.target.value)} className={`w-40 font-mono ${fieldCls}`} />}
      <button data-testid="casino-play" disabled={needsChoice && !f.choice} className={BTN_PRIMARY}>{PLAY_LABEL[game] || "Play"}</button>
    </form>
  );
};

export const ResultLine = ({ last, cur }) => (
  <p data-testid="casino-result" className={`mt-3 font-mono text-sm ${last.won ? "text-emerald-400" : "text-slate-400"}`}>{outcome(last, cur)}{detail(last)}{last.outcome && ` · ${last.outcome}`}</p>
);
